module.exports = __webpack_public_path__ + "5b4a33e176ff736a74f0ca2dd9e6b396.woff2";